import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import { toast } from 'react-toastify';

import Pagination from '../common/Pagination';
import Button from '../common/Button';

import { fetchDeleteCounteragent, fetchGetCounteragents } from '../../actions/settings';
import { showModal } from '../../actions/modal';

import { parseError } from '../../helpers';

import { COUNTRAGENTS_COUNT_ON_PAGE } from '../../config';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  .item-remove {
    display: none;
    cursor: pointer;
    padding: 10px 0;
  }

  .item-edit {
    cursor: pointer;
  }

  .edit-icon {
    margin-left: 5px;
    visibility: hidden;
  }

  .countragent-row:hover {
    .item-remove {
      display: block;
    }

    .edit-icon {
      visibility: visible;
    }
  }
`;

const CountragentsBlock = (props) => {
  const dispatch = useDispatch();
  const [countragents, setCountragents] = useState([]);
  const [countragentsTotal, setCountragentsTotal] = useState(0);
  const [countragentsCurrentPage, setCountragentsCurrentPage] = useState(0);
  const [search, setSearch] = useState('');

  const { t } = useAutoTranslation();

  const fetchCounteragentsList = (page) => {
    return dispatch(
      fetchGetCounteragents({
        page,
        size: COUNTRAGENTS_COUNT_ON_PAGE,
        query: search,
      }),
    ).then(({ counteragents, recordsTotal }) => {
      setCountragents(counteragents);
      setCountragentsTotal(recordsTotal);
      setCountragentsCurrentPage(page);
    });
  };

  useEffect(() => {
    fetchCounteragentsList(0);
  }, [search]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setCountragentsCurrentPage(0);
  };

  const handleUpdateCountragent = (id) => {
    //После любого редактирования API возвращает отредактированного контрагента в конце списка. Поэтому перелистываем список на последний лист пагинации.
    fetchCounteragentsList(Math.ceil(countragentsTotal / COUNTRAGENTS_COUNT_ON_PAGE) - 1);
    setCountragentsCurrentPage(Math.ceil(countragentsTotal / COUNTRAGENTS_COUNT_ON_PAGE) - 1);
  };

  const handleEditCountragent = (countragent) => {
    dispatch(
      showModal('EditCountragent', {
        countragent,
        handleUpdateCountragent,
      }),
    );
  };

  const handleDelete = (countragent) => {
    ////ToDo удаление контрагента не работает метод API
    dispatch(
      showModal('Confirm', {
        body: `${t('Подтвердите удаление контрагента')} "${countragent.name}"`,

        handleConfirm: async () => {
          await dispatch(fetchDeleteCounteragent(countragent.id)).catch((err) => {
            toast.error(parseError(err));
            throw err;
          });

          await fetchCounteragentsList(countragentsCurrentPage);
          toast.info(t('Контрагент успешно удален'));
        },

        confirmBtnTitle: t('Удалить'),
      }),
    );
  };

  return (
    <Fragment>
      <div className="border-bottom">
        <h4 className="header-title">{t('Контрагенты')}</h4>
      </div>

      <Wrapper style={{ paddingTop: '16px' }}>
        <div className="row" style={{ marginBottom: '16px' }}>
          <div className="col-lg-4">
            <label htmlFor="ordersSearch" className="sr-only">
              Search
            </label>
            <input
              type="text"
              className="form-control"
              id="ordersSearch"
              placeholder={t('Поиск: Наименование, ИНН, ОГРН')}
              value={search}
              onChange={handleSearch}
            />
          </div>
          <div className="col-lg-8">
            <div className="text-lg-right">
              <Button
                classType="btn-danger"
                type="button"
                icon="fe-plus"
                text={t('Новый контрагент')}
                onClick={() => handleEditCountragent(null)}
              />
            </div>
          </div>
        </div>

        <div className="fixed-table-container">
          <div className="table-responsive">
            <table className="table table-centered table-hover">
              <thead className="thead-light">
                <tr>
                  <th>{t('Наименование')}</th>
                  <th>{t('ИНН')}</th>
                  <th>{t('ОГРН')}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {countragents
                  ? countragents.map((countragent) => (
                      <tr key={countragent.id} className="countragent-row">
                        <td>
                          <div
                            className="item-edit"
                            onClick={() => handleEditCountragent(countragent)}
                          >
                            {countragent.name}
                            <i className="fe-edit-2 edit-icon" />
                          </div>
                        </td>
                        <td>
                          {countragent.type === 'COMPANY' && countragent.organization ? (
                            <Fragment>
                              <div>{countragent.organization.inn}</div>
                              {countragent.organization.kpp ? (
                                <div className="text-muted">
                                  {t('КПП')} {countragent.organization.kpp}
                                </div>
                              ) : null}
                            </Fragment>
                          ) : null}
                        </td>
                        <td>
                          {countragent.type === 'COMPANY' && countragent.organization
                            ? countragent.organization.ogrn
                            : null}
                        </td>
                        <td style={{ width: '45px', height: '70px' }}>
                          <div className="item-remove" onClick={() => handleDelete(countragent)}>
                            <i className="fe-trash-2" />
                          </div>
                        </td>
                      </tr>
                    ))
                  : null}
              </tbody>
            </table>
          </div>
        </div>

        <Pagination
          total={countragentsTotal}
          currentPage={countragentsCurrentPage}
          onPageSelect={fetchCounteragentsList}
          perPage={COUNTRAGENTS_COUNT_ON_PAGE}
        />
      </Wrapper>
    </Fragment>
  );
};

export default CountragentsBlock;
